interface DividerProps {
  orientation?: "horizontal" | "vertical";
  className?: string;
}

export function Divider({
  orientation = "vertical",
  className = "",
}: DividerProps) {
  return orientation === "vertical" ? (
    <div
      className={`w-px h-5 bg-border-subtle self-center ${className}`}
    />
  ) : (
    <div className={`h-px w-full bg-border-subtle ${className}`} />
  );
}
